const config = state => state.config

/**
 * @typedef {{}} Users~Frontend~Store~Getters
 * @property {function} config
 */
export default {
  config,
}
